import "core-js/modules/es.object.assign.js";
import _styled from "@emotion/styled/base";
function cov_200u59hqo8() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/growth/novo/inputs/Field.tsx";
  var hash = "583deacd049388fec79491cff1037202673c764e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/growth/novo/inputs/Field.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 21
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 38,
          column: 14
        },
        end: {
          line: 81,
          column: 1
        }
      },
      "2": {
        start: {
          line: 47,
          column: 21
        },
        end: {
          line: 47,
          column: 44
        }
      },
      "3": {
        start: {
          line: 48,
          column: 18
        },
        end: {
          line: 48,
          column: 37
        }
      },
      "4": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 80,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 38,
            column: 14
          },
          end: {
            line: 38,
            column: 15
          }
        },
        loc: {
          start: {
            line: 46,
            column: 21
          },
          end: {
            line: 81,
            column: 1
          }
        },
        line: 46
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 47,
            column: 21
          },
          end: {
            line: 47,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 21
          },
          end: {
            line: 47,
            column: 35
          }
        }, {
          start: {
            line: 47,
            column: 39
          },
          end: {
            line: 47,
            column: 44
          }
        }],
        line: 47
      },
      "1": {
        loc: {
          start: {
            line: 60,
            column: 7
          },
          end: {
            line: 64,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 63,
            column: 14
          }
        }, {
          start: {
            line: 64,
            column: 10
          },
          end: {
            line: 64,
            column: 14
          }
        }],
        line: 60
      },
      "2": {
        loc: {
          start: {
            line: 74,
            column: 7
          },
          end: {
            line: 78,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 77,
            column: 14
          }
        }, {
          start: {
            line: 78,
            column: 10
          },
          end: {
            line: 78,
            column: 14
          }
        }],
        line: 74
      },
      "3": {
        loc: {
          start: {
            line: 74,
            column: 7
          },
          end: {
            line: 74,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 7
          },
          end: {
            line: 74,
            column: 18
          }
        }, {
          start: {
            line: 74,
            column: 22
          },
          end: {
            line: 74,
            column: 31
          }
        }],
        line: 74
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "583deacd049388fec79491cff1037202673c764e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_200u59hqo8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_200u59hqo8();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import React from 'react';
import HelperText from "./HelperText.mjs";
import Input from "./Input.mjs";
import Label from "./Label.mjs";
var FieldElement = (cov_200u59hqo8().s[0]++, /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1bk473b0"
} : {
  target: "e1bk473b0",
  label: "FieldElement"
})(process.env.NODE_ENV === "production" ? {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column"
} : {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
}));

/**
 * When using a component that is not <Input> then <Field> expects you to tell
 * it what props it should be expecting: <Field<MyCoolCustomInputProps>
 * input={{...props for MyCoolCustomInput... }} />
 */
cov_200u59hqo8().s[1]++;
var Field = function Field(_ref) {
  var _ref2;
  var label = _ref.label,
    helperText = _ref.helperText,
    errorText = _ref.errorText,
    disabled = _ref.disabled,
    sizeVariant = _ref.sizeVariant,
    InputComponent = _ref.InputComponent,
    input = _ref.input;
  cov_200u59hqo8().f[0]++;
  var IComponent = (cov_200u59hqo8().s[2]++, (_ref2 = (cov_200u59hqo8().b[0][0]++, InputComponent)) !== null && _ref2 !== void 0 ? _ref2 : (cov_200u59hqo8().b[0][1]++, Input));
  var labelId = (cov_200u59hqo8().s[3]++, "".concat(input.id, "-label"));
  cov_200u59hqo8().s[4]++;
  return /*#__PURE__*/React.createElement(FieldElement, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: input.id,
    id: labelId,
    error: input.error,
    sizeVariant: sizeVariant,
    "data-has-error": input.error
  }, label), helperText ? (cov_200u59hqo8().b[1][0]++, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '4px'
    }
  }, /*#__PURE__*/React.createElement(HelperText, {
    error: input.error
  }, helperText))) : (cov_200u59hqo8().b[1][1]++, null), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '16px'
    }
  }, /*#__PURE__*/React.createElement(IComponent, _extends({
    labelId: labelId,
    error: input.error,
    disabled: disabled,
    sizeVariant: sizeVariant
  }, input))), (cov_200u59hqo8().b[3][0]++, input.error) && (cov_200u59hqo8().b[3][1]++, errorText) ? (cov_200u59hqo8().b[2][0]++, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '12px'
    }
  }, /*#__PURE__*/React.createElement(HelperText, {
    error: true
  }, errorText))) : (cov_200u59hqo8().b[2][1]++, null));
};
export default Field;
//# sourceMappingURL=Field.mjs.map